import 'babel-polyfill';

import React from 'react';
import ReactDom from 'react-dom';

import App from '../components/App';

ReactDom.render(<App />, document.getElementById('wrap'));

setTimeout(() => window.scrollTo(0,1), 1);



// WEBPACK FOOTER //
// ./src/js/index.js